export const nameImages = ['url_image', 'instructional_picture', 'data_sensors', 'url_instructional', 'url_sensors']

export const editKeysImages = {
    url_image: 'url_image',
    instructional_picture: 'url_instructional',
    data_sensors: 'url_sensors',
}

export const fieldsNeedTranslateArray = ['fieldsNeedTranslation','name','description','instructional_picture','data_sensors']
